module.exports = __webpack_public_path__ + "static/media/3.bdc272a8.png";